(function (module) {
  'use strict';
  module
    .controller('ActivateController', ['$scope', '$stateParams','$http', '$state', 'ngDialog', 'authService',
      function ($scope, $stateParams, $http, $state, ngDialog, authService) {
        var passwordRegex = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,})$/;
        $scope.user = {};
        $scope.validate = { //'valid', 'invalid', 'not-validated'          
          passwordValidity: 'not-validated',
          confirmValidity: 'not-validated',
        };

        $scope.passwordKeypress = function () {
          var isValid = passwordRegex.test($scope.user.password);
          $scope.validate.passwordValidity = isValid ? 'valid' : 'not-validated';
        };

        $scope.confirmKeypress = function () {
          if ($scope.user.confirm) {
            var isValid = passwordRegex.test($scope.user.confirm);
            $scope.validate.confirmValidity = ($scope.user.password === $scope.user.confirm && $scope.user.confirm.length >
              0 && isValid) ? 'valid' : 'not-validated';
          } else {
            $scope.validate.confirmValidity = 'not-validated';
          }
        };

        $scope.signup = function () {
          $scope.ajaxload = true;

          var isPasswordValid = passwordRegex.test($scope.user.password);
          if (!isPasswordValid) {
            $scope.validate.passwordValidity = 'invalid';
          }

          if ($scope.user.password !== $scope.user.confirm) {
            $scope.validate.confirmValidity = 'invalid';
          }

          var passwordInvalid = $scope.validate.passwordValidity === 'invalid',
            confirmInvalid = $scope.validate.confirmValidity === 'invalid';
          if (passwordInvalid || confirmInvalid) {
            $scope.ajaxload = false
            var dialog = ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = '';
                if (passwordInvalid) {
                  $scope.errMsg += '<p>Password must contain minimum 8 characters, and must include at least 1 uppercase letter and 1 digit.</p>';
                }
                if (confirmInvalid) {
                  $scope.errMsg += '<p>Password and Confirm Password fields do not match.</p>';
                }
                $scope.errTitle = 'Signing Up Error';
              },],
            });
            dialog.closePromise.then(function (data) {});
          } else {            
            authService.completeActivation($scope.user.password, $stateParams.guid)
              .then(
                result => {
                  $scope.ajaxload = false
                  const dialog = ngDialog.open({
                    template: 'templates/partials/viewSuccessMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.successMsg = 'You have successfully activated your account.';
                      $scope.strTitle = 'Activate Account Success';
                    },],
                  });
                  dialog.closePromise.then(function (data) {
                    if(isMobile.any()) {
                      $state.go('closepage');
                    } else {
                      $state.go('login');
                    }
                  });
                },
                error => {
                  $scope.ajaxload = false
                  const dialog = ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${error.data}</p>`;
                      $scope.errTitle = 'Signing Up Error';
                    },],
                  });
                  dialog.closePromise.then(function (data) {});
                }
              );            
          }                      
        };

        const isMobile = {
          Android: function() {
              return navigator.userAgent.match(/Android/i);
          },
          BlackBerry: function() {
              return navigator.userAgent.match(/BlackBerry/i);
          },
          iOS: function() {
              return navigator.userAgent.match(/iPhone|iPad|iPod/i);
          },
          Opera: function() {
              return navigator.userAgent.match(/Opera Mini/i);
          },
          Windows: function() {
              return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
          },
          any: function() {
              return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
          }
        };        

        console.log($stateParams);
        console.log($stateParams.guid);
      }
  ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/activateController.js